import { ConfigAService } from "../services/config.service";

export function PreloadFactory(configService: ConfigAService) {
  return () => configService.getBaseURL();
}
